import React from 'react';
import MobilePhoneFrame from '../../../../static/images/experiences/mobile_phone_frame.png';

const VideoItem = ({ title, text, icon, video }) => {
    return (
        <>
            <div className="flex flex-col space-y-8 lg:w-2/3">
                <div className="hidden lg:flex space-x-10 items-center">
                    <div className="relative w-8 h-8">
                        <img src={icon} alt="Stadium Tour" />
                        <div className="icon-circle"></div>
                    </div>

                    <h1 className="card-title">{title}</h1>
                </div>
                <span className="text-card-text-color text-justify md:text-left w-full xl:w-2/3">
                    {text}
                </span>
            </div>
            <div className="w-full lg:w-1/3">
                <div className="relative max-w-max m-auto">
                    <img
                        src={MobilePhoneFrame}
                        alt="Mobile phone Stadium Tour experience"
                        className="relative pointer-events-none z-10 w-full lg:w-auto"
                    />
                    <video
                        key={video}
                        autoPlay
                        muted
                        loop
                        playsInline
                        className="absolute top-0 left-0 w-full h-full object-cover rounded pointer-events-none video-inside-frame bg-card-color"
                    >
                        <source src={video} type="video/mp4" />
                        <track kind="captions" srcLang="en" src="" />
                    </video>
                </div>
            </div>
        </>
    );
};

export default VideoItem;
